export { IssueFeed } from './issues'
export type { FeedComponentProps } from './interface'
